import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home.vue'
import M_Home from '@/views/mobile/home/M_Home.vue'
import NotFound from '@/views/other/NotFound.vue'
import { createColumnMeta } from '@/utils/util.js'

Vue.use(VueRouter)

const redirectPath = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent) ? '/M' : '/Home'
const routes = [{
        path: '/',
        redirect: redirectPath
    },
    {
        path: '/Home',
        name: 'Home',
        component: Home,
        title: '首页',
        meta: {
            title: '首页',
            type: 'pc'
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "userLogin" */ '@/views/userLogin/Login.vue'),
        meta: {
            title: '用户查询',
            type: 'pc'
        },
        beforeEnter: (to, from, next) => {
            console.log('from', from, 'to:', to);
            localStorage.setItem('fromUrlName', from.name)
            next()
        }
    },
    {
        path: '/detail/:id',
        name: 'Detail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/Detail.vue'),
        title: '内容页',
        meta: {
            type: 'pc'
        },
    },
    {
        path: '/veteranDetail/:id',
        name: 'VeteranDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/VeteranDetail.vue'),
        title: '培训信息内容页',
        meta: {
            type: 'pc'
        },
    },
    {
        path: '/consultDetail/:id',
        name: 'ConsultDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/ConsultDetail.vue'),
        title: '咨询信息内容页',
        meta: {
            type: 'pc'
        },
    },
    {
        path: '/investigationDetail/:id',
        name: 'InvestigationDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/InvestigationDetail.vue'),
        title: '意见征集内容页',
        meta: {
            type: 'pc'
        },
    },
    {
        path: '/recruitDetail/:id',
        name: 'RecruitDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/RecruitDetail.vue'),
        title: '招聘信息内容页',
        meta: {
            type: 'pc'
        },
    },
    {
        path: '/resumeDetail/:id',
        name: 'ResumeDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/ResumeDetail.vue'),
        title: '个人简历内容页',
        meta: {
            type: 'pc',
            isLogin: true
        },
    },
    {
        path: '/trainDetail/:id',
        name: 'TrainDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/detail/TrainDetail.vue'),
        title: '我的培训内容页',
        meta: {
            type: 'pc',
            isLogin: true
        },
    },
    {
        path: '/investigation',
        name: 'Investigation',
        component: () =>
            import ( /* webpackChunkName: "other" */ '@/views/other/Investigation.vue'),
        meta: {
            title: '意见征集',
            type: 'pc'
        },
    },
    // {
    //     path: '/serviceHall',
    //     name: 'ServiceHall',
    //     component: () =>
    //         import ( /* webpackChunkName: "other" */ '@/views/other/ServiceHall.vue'),
    //     title: '预约服务大厅',
    //     meta: {
    //         title: '预约服务大厅',
    //         type: 'pc'
    //     },
    // },
    {
        path: '/news',
        name: 'News',
        title: '公告公示',
        component: () =>
            import ( /* webpackChunkName: "news" */ '@/views/news/NewsAnnouncement.vue'),
        meta: {
            title: '公告公示',
            type: 'pc'
        },
        redirect: {
            name: 'Notice'
        },
        children: [{
                path: 'notice',
                name: 'Notice',
                title: '公告通知',
                component: () =>
                    import ( /* webpackChunkName: "news" */ '@/views/news/Notice.vue'),
                meta: {
                    title: '公告通知',
                    type: 'pc'
                },

            },
            {
                path: 'announce',
                name: 'Announce',
                title: '公示信息',
                component: () =>
                    import ( /* webpackChunkName: "news" */ '@/views/news/Announce.vue'),
                meta: {
                    title: '公示信息',
                    type: 'pc'
                },

            },
            {
                path: 'newsInformation',
                name: 'NewsInformation',
                component: () =>
                    import ( /* webpackChunkName: "news" */ '@/views/news/NewsInformation.vue'),
                meta: {
                    title: '新闻发布',
                    type: 'pc'
                },

            },
        ],
    },
    {
        path: '/serviceGuide',
        name: 'ServiceGuide',
        title: '办事指南',
        component: () =>
            import ( /* webpackChunkName: "serviceGuide" */ '@/views/serviceGuide/ServiceGuide.vue'),
        meta: {
            title: '办事指南',
            type: 'pc'
        },
        redirect: {
            name: 'SelfEmployment'
        },
        children: [{
                path: 'selfEmployment',
                name: 'SelfEmployment',
                title: '军转干部',
                component: () =>
                    import ( /* webpackChunkName: "serviceGuide" */ '@/views/serviceGuide/SelfEmployment.vue'),
                meta: {
                    title: '军转干部',
                    type: 'pc'
                },
            },
            {
                path: 'campFamily',
                name: 'CampFamily',
                title: '随军家属',
                component: () =>
                    import ( /* webpackChunkName: "serviceGuide" */ '@/views/serviceGuide/CampFamily.vue'),
                meta: {
                    title: '随军家属',
                    type: 'pc'
                },
            },
            {
                path: 'receiveMonthly',
                name: 'ReceiveMonthly',
                title: '逐月领取退役金',
                component: () =>
                    import ( /* webpackChunkName: "serviceGuide" */ '@/views/serviceGuide/ReceiveMonthly.vue'),
                meta: {
                    title: '逐月领取退役金',
                    type: 'pc'
                },
            },
            {
                path: 'business',
                name: 'Business',
                title: '业务办理指南',
                component: () =>
                    import ( /* webpackChunkName: "serviceGuide" */ '@/views/serviceGuide/Business.vue'),
                meta: {
                    title: '业务办理指南',
                    type: 'pc'
                },
            },
        ],
    },
    {
        path: '/policies',
        name: 'Policies',
        title: '办事规定',
        component: () =>
            import ( /* webpackChunkName: "policies" */ '@/views/policies/Policies.vue'),
        meta: {
            title: '办事规定',
            type: 'pc'
        },
    },
    {
        path: '/recruitment',
        name: 'Recruitment',
        title: '求职招聘',
        component: () =>
            import ( /* webpackChunkName: "recruitment" */ '@/views/recruitment/Recruitment.vue'),
        meta: {
            title: '求职招聘',
            type: 'pc'
        },
        redirect: {
            name: 'RecruitmentInfo'
        },
        children: [{
            path: 'recruitmentInfo',
            name: 'RecruitmentInfo',
            component: () =>
                import ( /* webpackChunkName: "recruitment" */ '@/views/recruitment/RecruitmentInfo.vue'),
            meta: {
                title: '招聘信息',
                type: 'pc'
            },
        }, ],
    },
    {
        path: '/training',
        name: 'Training',
        title: '教育培训',
        component: () =>
            import ( /* webpackChunkName: "training" */ '@/views/training/Training.vue'),
        meta: {
            title: '教育培训',
            type: 'pc'
        },
        redirect: {
            name: 'TrainingNotice'
        },
        children: [{
                path: 'notice',
                name: 'TrainingNotice',
                title: '培训通知',
                component: () =>
                    import ( /* webpackChunkName: "training" */ '@/views/training/Notice.vue'),
                meta: {
                    title: '培训通知',
                    type: 'pc'
                },
            },
            {
                path: 'course',
                name: 'Course',
                title: '课程查询',
                component: () =>
                    import ( /* webpackChunkName: "training" */ '@/views/training/Course.vue'),
                meta: {
                    title: '课程查询',
                    type: 'pc'
                },
            },
        ],
    },
    {
        path: '/character',
        name: 'Character',
        title: '人物风采',
        component: () =>
            import ( /* webpackChunkName: "character" */ '@/views/character/Character.vue'),
        meta: {
            title: '人物风采',
            type: 'pc'
        },
    },
    {
        path: '/consultation',
        name: 'Consultation',
        title: '问题咨询',
        component: () =>
            import ( /* webpackChunkName: "consultation" */ '@/views/consultation/Consultation.vue'),
        meta: {
            title: '问题咨询',
            type: 'pc'
        },
        redirect: {
            name: 'CommonProblem'
        },
        children: [{
                path: 'commonProblem',
                name: 'CommonProblem',
                title: '常见问题',
                component: () =>
                    import ( /* webpackChunkName: "consultation" */ '@/views/consultation/CommonProblem.vue'),
                meta: {
                    title: '常见问题',
                    type: 'pc'
                },
            },
            {
                path: 'interaction',
                name: 'Interaction',
                title: '来信选登',
                component: () =>
                    import ( /* webpackChunkName: "consultation" */ '@/views/consultation/Interaction.vue'),
                meta: {
                    title: '来信选登',
                    type: 'pc'
                },
            },
        ],
    },
    {
        path: '/about',
        name: 'About',
        title: '关于我们',
        component: () =>
            import ( /* webpackChunkName: "about" */ '@/views/about/About.vue'),
        meta: {
            title: '关于我们',
            type: 'pc'
        },
        redirect: {
            name: 'Contact'
        },
        children: [{
                path: 'contact',
                name: 'Contact',
                title: '中心简介',
                component: () =>
                    import ( /* webpackChunkName: "about" */ '@/views/about/Contact.vue'),
                meta: {
                    title: '中心简介',
                    type: 'pc'
                },
            },
            {
                path: 'siteMap',
                name: 'SiteMap',
                title: '本站地图',
                component: () =>
                    import ( /* webpackChunkName: "about" */ '@/views/about/SiteMap.vue'),
                meta: {
                    title: '本站地图',
                    type: 'pc'
                },
            },
        ],
    },
    {
        path: '/personalServices',
        name: 'PersonalServices',
        component: () =>
            import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/PersonalServices.vue'),
        meta: {
            title: '服务',
            type: 'pc'
        },
        children: [{
                path: 'pensionInquiry',
                name: 'PensionInquiry',
                title: '病故军人抚恤金查询',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/PensionInquiry.vue'),
                meta: {
                    title: '病故军人抚恤金查询',
                    type: 'pc'
                },
            },
            {
                path: 'soldierReport',
                name: 'SoldierReport',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/SoldierReport.vue'),
                meta: {
                    title: '退役士兵报到',
                    type: 'pc'
                },
            },
            {
                path: 'soldierReportNotice',
                name: 'SoldierReportNotice',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/SoldierReportNotice.vue'),
                meta: {
                    title: '退役士兵报到须知',
                    type: 'pc'
                },
            },
            {
                path: 'interactiveConsultation',
                name: 'InteractiveConsultation',
                title: '互动咨询',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/InteractiveConsultation.vue'),
                meta: {
                    title: '互动咨询',
                    type: 'pc'
                },
            },
            {
                path: 'interactiveConsultationTip',
                name: 'InteractiveConsultationTip',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/InteractiveConsultationTip.vue'),
                meta: {
                    title: '温馨提示',
                    type: 'pc'
                },
            },
            {
                path: 'weChatVisits',
                name: 'WeChatVisits',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/WeChatVisits.vue'),
                meta: {
                    title: '微信访',
                    type: 'pc'
                },
            },
            {
                path: 'weChatVisitsNotice',
                name: 'WeChatVisitsNotice',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/WeChatVisitsNotice.vue'),
                meta: {
                    title: '微信访须知',
                    type: 'pc'
                },
            },
            {
                path: 'pensionHandling',
                name: 'PensionHandling',
                title: '病故军人一次性抚恤金办理须知',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/PensionHandling.vue'),
                meta: {
                    title: '病故军人一次性抚恤金办理须知',
                    type: 'pc'
                },
            },
            {
                path: 'pensionCheck',
                name: 'PensionCheck',
                title: '病故军人一次性抚恤金审批查询',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/PensionCheck.vue'),
                meta: {
                    title: '病故军人一次性抚恤金审批查询',
                    type: 'pc'
                },
            },
            {
                path: 'uploadData',
                name: 'UploadData',
                title: '上传资料',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/UploadData.vue'),
                meta: {
                    title: '上传资料',
                    type: 'pc'
                },
            },
            {
                path: 'instructionsForTreatment',
                name: 'InstructionsForTreatment',
                title: '优抚科办理须知',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/InstructionsForTreatment.vue'),
                meta: {
                    title: '优抚科办理须知',
                    type: 'pc'
                },
            },
            {
                path: 'authentication',
                name: 'Authentication',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/Authentication.vue'),
                meta: {
                    title: '认证',
                    type: 'pc'
                },
            },
            {
                path: 'authenticationProcess',
                name: 'AuthenticationProcess',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/AuthenticationProcess.vue'),
                meta: {
                    title: '认证审核',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'authenticationEdit',
                name: 'AuthenticationEdit',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/AuthenticationEdit.vue'),
                meta: {
                    title: '重新编辑审核信息',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilyAppointment',
                name: 'MilitaryFamilyAppointment',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilyAppointment.vue'),
                meta: {
                    title: '随军家属业务预约',
                    type: 'pc'
                },
            },
            {
                path: 'ServiceHall',
                name: 'ServiceHall',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/ServiceHall.vue'),
                meta: {
                    title: '预约大厅',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilyReview',
                name: 'MilitaryFamilyReview',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilyReview.vue'),
                meta: {
                    title: '接收函办理须知',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilyApply',
                name: 'MilitaryFamilyApply',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilyApply.vue'),
                meta: {
                    title: '随军家属接收预审核',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilyLetter',
                name: 'MilitaryFamilyLetter',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilyLetter.vue'),
                meta: {
                    title: '存档介绍信办理须知',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilySubsidy',
                name: 'MilitaryFamilySubsidy',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilySubsidy.vue'),
                meta: {
                    title: '按照无业办理随军手续的随军家属报到及生活补助申领',
                    type: 'pc'
                },
            },
            {
                path: 'militaryFamilyOther',
                name: 'MilitaryFamilyOther',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/personalServices/MilitaryFamilyOther.vue'),
                meta: {
                    title: '其他区接收的落户在海淀区的随军家属相关业务',
                    type: 'pc'
                },
            },
        ]
    },
    {
        path: '/scoreQuery',
        name: 'ScoreQuery',
        title: '成绩查询',
        component: () =>
            import ( /* webpackChunkName: "other" */ '@/views/other/ScoreQuery.vue'),
        meta: {
            title: '成绩查询',
            type: 'pc'
        },
    },
    {
        path: '/userSpace',
        name: 'Space',
        component: () =>
            import ( /* webpackChunkName: "space" */ '@/views/userSpace/Space.vue'),
        meta: {
            title: '用户中心',
            type: 'pc',
            isLogin: true
        },
        redirect: {
            name: 'PersonalInfo'
        },
        children: [{
                path: 'personalInfo',
                name: 'PersonalInfo',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalInfo.vue'),
                meta: {
                    title: '个人信息',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalMessage',
                name: 'PersonalMessage',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalMessage.vue'),
                meta: {
                    title: '我的消息',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalTrain',
                name: 'PersonalTrain',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalTrain.vue'),
                meta: {
                    title: '我的培训',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalResume',
                name: 'PersonalResume',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalResume.vue'),
                meta: {
                    title: '个人简历',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoListSingle',
                name: 'RecruitmentInfoListSingle',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/RecruitmentInfoListSingle.vue'),
                meta: {
                    title: '已投递信息',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalQuestionnaire',
                name: 'PersonalQuestionnaire',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalQuestionnaire.vue'),
                meta: {
                    title: '意见征集',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalConsulting',
                name: 'PersonalConsulting',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalConsulting.vue'),
                meta: {
                    title: '我的咨询',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalAppointment',
                name: 'PersonalAppointment',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalAppointment.vue'),
                meta: {
                    title: '我的预约',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'personalVisits',
                name: 'PersonalVisits',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/PersonalVisits.vue'),
                meta: {
                    title: '我的信访',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfo',
                name: 'SpaceRecruitmentInfo',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/RecruitmentInfo.vue'),
                meta: {
                    title: '招聘信息',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoList',
                name: 'RecruitmentInfoList',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/RecruitmentInfoList.vue'),
                meta: {
                    title: '投递明细',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentResumeList',
                name: 'RecruitmentResumeList',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/RecruitmentResumeList.vue'),
                meta: {
                    title: '简历列表',
                    type: 'pc',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoPublish',
                name: 'RecruitmentInfoPublish',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/userSpace/RecruitmentInfoPublish.vue'),
                meta: {
                    title: '发布招聘信息',
                    type: 'pc',
                    isLogin: true
                },
            },
        ],
    },
    /* ================================ 移动端路由 ================================ */
    {
        path: '/M',
        name: 'M_Home',
        component: M_Home,
        meta: {
            title: '首页',
            type: 'mobile'
        },
    },
    {
        path: '/M/detail/:id',
        name: 'M_Detail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/Detail.vue'),
        meta: {
            title: '内容页',
            type: 'mobile'
        },
    },
    {
        path: '/M/appointmentDetail/:id',
        name: 'M_AppointmentDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/AppointmentDetail.vue'),
        meta: {
            title: '我的预约内容页',
            type: 'mobile'
        },
    },
    {
        path: '/M/recruitDetail/:id',
        name: 'M_RecruitDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/RecruitDetail.vue'),
        title: '招聘信息内容页',
        meta: {
            type: 'mobile'
        },
    },
    {
        path: '/M/resumeDetail/:id',
        name: 'M_ResumeDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/ResumeDetail.vue'),
        meta: {
            type: 'mobile',
            isLogin: true
        },
    },
    {
        path: '/M/veteranDetail/:id',
        name: 'M_VeteranDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/VeteranDetail.vue'),
        meta: {
            title: '培训信息内容页',
            type: 'mobile'
        },
    },
    {
        path: '/M/trainDetail/:id',
        name: 'M_TrainDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/TrainDetail.vue'),
        meta: {
            title: '我的培训内容页',
            type: 'mobile',
            isLogin: true
        },
    },
    {
        path: '/M/news',
        name: 'M_News',
        component: () =>
            import ( /* webpackChunkName: "news" */ '@/views/mobile/news/NewsAnnouncement_M.vue'),
        meta: {
            type: 'mobile'
        },
        redirect: {
            name: 'M_Notice'
        },
        children: [{
                path: 'notice',
                name: 'M_Notice',
                component: () =>
                    import ( /* webpackChunkName: "news" */ '@/views/mobile/news/Notice_M.vue'),
                meta: {
                    title: '公告通知',
                    type: 'mobile'
                },

            },
            {
                path: 'announce',
                name: 'M_Announce',
                component: () =>
                    import ( /* webpackChunkName: "news" */ '@/views/mobile/news/Announce_M.vue'),
                meta: {
                    title: '公示信息',
                    type: 'mobile'
                },

            },
        ],
    },
    {
        path: '/M/serviceGuide',
        name: 'M_ServiceGuide',
        title: '办事指南',
        component: () =>
            import ( /* webpackChunkName: "serviceGuide" */ '@/views/mobile/serviceGuide/ServiceGuide.vue'),
        meta: {
            title: '办事指南',
            type: 'mobile'
        }
    },
    {
        path: '/M/policies',
        name: 'M_Policies',
        component: () =>
            import ( /* webpackChunkName: "policies" */ '@/views/mobile/policies/Policies.vue'),
        meta: {
            title: '办事规定',
            type: 'mobile'
        },
    },
    {
        path: '/M/recruitment',
        name: 'M_Recruitment',
        component: () =>
            import ( /* webpackChunkName: "recruitment" */ '@/views/mobile/recruitment/Recruitment.vue'),
        meta: {
            title: '招聘信息',
            type: 'mobile'
        },
    },
    {
        path: '/M/training',
        name: 'M_Training',
        component: () =>
            import ( /* webpackChunkName: "training" */ '@/views/mobile/training/Training.vue'),
        meta: {
            title: '教育培训',
            type: 'mobile'
        },
        redirect: {
            name: 'M_TrainingNotice'
        },
        children: [{
                path: 'notice',
                name: 'M_TrainingNotice',
                component: () =>
                    import ( /* webpackChunkName: "training" */ '@/views/mobile/training/Notice.vue'),
                meta: {
                    title: '培训通知',
                    type: 'mobile'
                },
            },
            {
                path: 'course',
                name: 'M_Course',
                component: () =>
                    import ( /* webpackChunkName: "training" */ '@/views/mobile/training/Course.vue'),
                meta: {
                    title: '课程查询',
                    type: 'mobile'
                },
            },
        ],
    },
    {
        path: '/M/investigation',
        name: 'M_Investigation',
        component: () =>
            import ( /* webpackChunkName: "other" */ '@/views/mobile/other/Investigation.vue'),
        meta: {
            title: '意见征集',
            type: 'mobile'
        },
    },
    {
        path: '/M/investigationDetail/:id',
        name: 'M_InvestigationDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/InvestigationDetail.vue'),
        title: '意见征集内容页',
        meta: {
            type: 'mobile'
        },
    },
    {
        path: '/M/consultation',
        name: 'M_Consultation',
        component: () =>
            import ( /* webpackChunkName: "consultation" */ '@/views/mobile/consultation/Consultation.vue'),
        meta: {
            title: '问题咨询',
            type: 'mobile'
        },
        redirect: {
            name: 'M_CommonProblem'
        },
        children: [{
                path: 'commonProblem',
                name: 'M_CommonProblem',
                component: () =>
                    import ( /* webpackChunkName: "consultation" */ '@/views/mobile/consultation/CommonProblem.vue'),
                meta: {
                    title: '常见问题',
                    type: 'mobile'
                },
            },
            {
                path: 'interaction',
                name: 'M_Interaction',
                component: () =>
                    import ( /* webpackChunkName: "consultation" */ '@/views/mobile/consultation/Interaction.vue'),
                meta: {
                    title: '来信选登',
                    type: 'mobile'
                },
            },
        ],
    },
    {
        path: '/M/consultDetail/:id',
        name: 'M_ConsultDetail',
        component: () =>
            import ( /* webpackChunkName: "detail" */ '@/views/mobile/detail/ConsultDetail.vue'),
        title: '咨询信息内容页',
        meta: {
            type: 'mobile'
        },
    },
    {
        path: '/M/character',
        name: 'M_Character',
        component: () =>
            import ( /* webpackChunkName: "character" */ '@/views/mobile/character/Character.vue'),
        meta: {
            title: '人物风采',
            type: 'mobile'
        },
    },
    {
        path: '/M/service',
        name: 'M_Service',
        component: () =>
            import ( /* webpackChunkName: "service" */ '@/views/mobile/service/Service.vue'),
        meta: {
            title: '服务',
            type: 'mobile'
        },
    },
    {
        path: '/M/login',
        name: 'M_Login',
        component: () =>
            import ( /* webpackChunkName: "userLogin" */ '@/views/mobile/userLogin/Login.vue'),
        meta: {
            title: '用户查询',
            type: 'mobile'
        },
        beforeEnter: (to, from, next) => {
            localStorage.setItem('fromUrlName', from.fullPath)
            next()
        }
    },
    {
        path: '/M/userSpace',
        name: 'M_Space',
        component: () =>
            import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/Space.vue'),
        meta: {
            title: '用户中心',
            type: 'mobile',
            isLogin: true
        },
        redirect: {
            name: 'M_My'
        },
        children: [{
                path: 'my',
                name: 'M_My',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/My.vue'),
                meta: {
                    title: '我的',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalMessage',
                name: 'M_PersonalMessage',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalMessage.vue'),
                meta: {
                    title: '我的消息',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalTrain',
                name: 'M_PersonalTrain',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalTrain.vue'),
                meta: {
                    title: '我的培训',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalConsulting',
                name: 'M_PersonalConsulting',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalConsulting.vue'),
                meta: {
                    title: '我的咨询',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalVisits',
                name: 'M_PersonalVisits',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalVisits.vue'),
                meta: {
                    title: '我的信访',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalAppointment',
                name: 'M_PersonalAppointment',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalAppointment.vue'),
                meta: {
                    title: '我的预约',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfo',
                name: 'M_SpaceRecruitmentInfo',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RecruitmentInfo.vue'),
                meta: {
                    title: '我的招聘',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoEdit',
                name: 'M_RecruitmentInfoEdit',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RecruitmentInfoEdit.vue'),
                meta: {
                    title: '编辑招聘信息',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoList',
                name: 'M_RecruitmentInfoList',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RecruitmentInfoList.vue'),
                meta: {
                    title: '投递明细',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentResumeList',
                name: 'M_RecruitmentResumeList',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RecruitmentResumeList.vue'),
                meta: {
                    title: '简历列表',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'recruitmentInfoListSingle',
                name: 'M_RecruitmentInfoListSingle',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RecruitmentInfoListSingle.vue'),
                meta: {
                    title: '已投递信息',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'personalResume',
                name: 'M_PersonalResume',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/PersonalResume.vue'),
                meta: {
                    title: '个人简历',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeBaseInfo',
                name: 'M_ResumeBaseInfo',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeBaseInfo.vue'),
                meta: {
                    title: '修改简历基本信息',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeIntro',
                name: 'M_ResumeIntro',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeIntro.vue'),
                meta: {
                    title: '修改个人简介',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeEducation',
                name: 'M_ResumeEducation',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeEducation.vue'),
                meta: {
                    title: '修改教育经历',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeWorkExp',
                name: 'M_ResumeWorkExp',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeWorkExp.vue'),
                meta: {
                    title: '修改工作经历',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeTraining',
                name: 'M_ResumeTraining',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeTraining.vue'),
                meta: {
                    title: '修改培训经历',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'rusumeLang',
                name: 'M_RusumeLang',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/RusumeLang.vue'),
                meta: {
                    title: '修改语言能力',
                    type: 'mobile',
                    isLogin: true
                },
            },
            {
                path: 'resumeCertificate',
                name: 'M_ResumeCertificate',
                component: () =>
                    import ( /* webpackChunkName: "space" */ '@/views/mobile/userSpace/ResumeCertificate.vue'),
                meta: {
                    title: '修改获得证书',
                    type: 'mobile',
                    isLogin: true
                },
            },
        ],
    },
    {
        path: '/M/about',
        name: 'M_About',
        component: () =>
            import ( /* webpackChunkName: "about" */ '@/views/mobile/about/About.vue'),
        meta: {
            title: '关于我们',
            type: 'mobile'
        },
    },
    {
        path: '/M/personalServices',
        name: 'M_PersonalServices',
        component: () =>
            import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/PersonalServices.vue'),
        meta: {
            title: '服务',
            type: 'mobile'
        },
        children: [{
                path: 'soldierReport',
                name: 'M_SoldierReport',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/SoldierReport.vue'),
                meta: {
                    title: '退役士兵报到',
                    type: 'mobile'
                },
            },
            {
                path: 'soldierReportNotice',
                name: 'M_SoldierReportNotice',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/SoldierReportNotice.vue'),
                meta: {
                    title: '退役士兵报到须知',
                    type: 'mobile'
                },
            },
            {
                path: 'serviceHall',
                name: 'M_ServiceHall',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/ServiceHall.vue'),
                meta: {
                    title: '预约服务大厅',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyOther',
                name: 'M_MilitaryFamilyOther',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyOther.vue'),
                meta: {
                    title: '其他区接收的落户在海淀区的随军家属相关业务',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyReview',
                name: 'M_MilitaryFamilyReview',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyReview.vue'),
                meta: {
                    title: '接收函办理须知',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyLetter',
                name: 'M_MilitaryFamilyLetter',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyLetter.vue'),
                meta: {
                    title: '存档介绍信办理须知',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyLetterAppointment',
                name: 'M_MilitaryFamilyLetterAppointment',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyLetterAppointment.vue'),
                meta: {
                    title: '存档介绍信办理预约',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyApply',
                name: 'M_MilitaryFamilyApply',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyApply.vue'),
                meta: {
                    title: '接收函填写-申请人须知',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyApplyAdd',
                name: 'M_MilitaryFamilyApplyAdd',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyApplyAdd.vue'),
                meta: {
                    title: '接收函办理须知-家庭信息',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilySubsidy',
                name: 'M_MilitaryFamilySubsidy',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilySubsidy.vue'),
                meta: {
                    title: '按照无业办理随军手续的随军家属报到及生活补助申领',
                    type: 'mobile'
                },
            },
            {
                path: 'militaryFamilyAppointment',
                name: 'M_MilitaryFamilyAppointment',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/MilitaryFamilyAppointment.vue'),
                meta: {
                    title: '随军家属业务预约',
                    type: 'mobile'
                },
            },
            {
                path: 'pensionHandling',
                name: 'M_PensionHandling',
                title: '病故军人一次性抚恤金办理须知',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/PensionHandling.vue'),
                meta: {
                    title: '病故军人一次性抚恤金办理须知',
                    type: 'mobile'
                },
            },
            {
                path: 'pensionCheck',
                name: 'M_PensionCheck',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/PensionCheck.vue'),
                meta: {
                    title: '病故军人一次性抚恤金审批查询',
                    type: 'mobile'
                },
            },
            {
                path: 'uploadData',
                name: 'M_UploadData',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/UploadData.vue'),
                meta: {
                    title: '上传资料',
                    type: 'mobile'
                },
            },
            {
                path: 'pensionInquiry',
                name: 'M_PensionInquiry',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/PensionInquiry.vue'),
                meta: {
                    title: '病故军人抚恤金查询',
                    type: 'mobile'
                },
            },
            {
                path: 'interactiveConsultation',
                name: 'M_InteractiveConsultation',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/InteractiveConsultation.vue'),
                meta: {
                    title: '互动咨询',
                    type: 'mobile'
                },
            },
            {
                path: 'interactiveConsultationTip',
                name: 'M_InteractiveConsultationTip',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/InteractiveConsultationTip.vue'),
                meta: {
                    title: '温馨提示-互动咨询',
                    type: 'mobile'
                },
            },
            {
                path: 'weChatVisitsNotice',
                name: 'M_WeChatVisitsNotice',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/WeChatVisitsNotice.vue'),
                meta: {
                    title: '微信访须知',
                    type: 'mobile'
                },
            },
            {
                path: 'weChatVisits',
                name: 'M_WeChatVisits',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/WeChatVisits.vue'),
                meta: {
                    title: '微信访',
                    type: 'mobile'
                },
            },
            {
                path: 'authentication',
                name: 'M_Authentication',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/Authentication.vue'),
                meta: {
                    title: '认证',
                    type: 'mobile'
                },
            },
            {
                path: 'authenticationProcess',
                name: 'M_AuthenticationProcess',
                component: () =>
                    import ( /* webpackChunkName: "personalServices" */ '@/views/mobile/personalServices/AuthenticationProcess.vue'),
                meta: {
                    title: '认证审核',
                    type: 'mobile',
                    isLogin: true
                },
            },
        ]
    },
    // {
    //     path: '/M/serviceHall',
    //     name: 'M_ServiceHall',
    //     component: () =>
    //         import ( /* webpackChunkName: "other" */ '@/views/mobile/other/ServiceHall.vue'),
    //     meta: {
    //         title: '预约服务大厅',
    //         type: 'mobile'
    //     },
    // },
    {
        path: '*',
        name: 'NotFound',
        title: '404',
        component: NotFound,
        meta: {
            type: 'pc'
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/tyjr',
    routes
})

router.beforeEach((to, from, next) => {
    console.log('to.fullPath', to);
    // 设置meta标签
    if (to.title || to.meta.title) {
        createColumnMeta(to.title || to.meta.title)
    }

    document.title = '海淀区退役军人服务平台';
    // 返回顶部
    window, scrollTo(0, 0)
        // 是否是移动端
    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)
        // 登录判断
    if (to.meta.isLogin && !isMobile) {
        if (!localStorage.getItem('token')) {
            next({ name: 'Login' })
        }
    }
    // 移动端登录判断
    if (to.meta.isLogin && isMobile) {
        if (!localStorage.getItem('token')) {
            next({ name: 'M_Login' })
        }
    }
    if (to.fullPath.indexOf('/receiveMonthly') !== -1) {
        next({ name: 'Home' })
    }
    if (to.fullPath.indexOf('/campFamily') !== -1) {
        next({ name: 'Home' })
    }
    // 频道跳转
    if (isMobile) {
        if (to.meta.type !== 'mobile') {
            if (to.fullPath.indexOf('/serviceGuide') !== -1) {
                next('/M/serviceGuide')
            } else if (to.fullPath === '/recruitment/recruitmentInfo') {
                next({ name: 'M_Recruitment' })
            } else if (to.fullPath === '/about/contact' || to.fullPath === '/about/siteMap') {
                next('/M/about')
            } else if (to.fullPath === '/news/newsInformation') {
                next('/M')
            } else if (to.fullPath === '/scoreQuery') {
                next('/M')
            } else if (to.fullPath === '/Home') {
                next('/M')
            } else {
                let url = '/M' + to.fullPath
                next(url)
            }
            // console.log('toPath', to);
        }
    } else {
        if (to.meta.type === 'mobile') {
            next("/Home")
        }
    }
    next()
})

export default router